import PageProtectedLayout from "../../../../components/Page/PageProtectedLayout.jsx";
import SelectDateOmega from "./SelectDateOmega.jsx";
import { useTranslation } from '../../../../language';

export default function BloodOmegaWelcome() {

  const { t } = useTranslation();

return (

    <PageProtectedLayout

      headline={t('page_hl_omega')}
      specify={t('page_sp_omega_lifestyle')}

      >

      {/* Main Page Content */}
     <SelectDateOmega />

    </PageProtectedLayout>

  );
}
